import { render } from "./MesComponent.vue?vue&type=template&id=74f8ffa6"
import script from "./MesComponent.vue?vue&type=script&lang=js"
export * from "./MesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__